import { styled, Button } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  paddingLeft: 0,
  color: theme.palette.custom.textColors[700]
}));
